export enum PrinterType {
  None,
  Thermo
}
